<template>
	<div class="contain">

		<div v-show="toggleModal" class="modal-mask">
		<div class="modal-wrapper">
			<div class="modal-container">
			<div class="modal-header">

			</div>
			<div class="modal-body">
				<slot name="body" class="text-center">
					Rolling back record...
					<div v-if="revertLoading" class="fa-3x text-center" style="margin-top: 10px">
						<i class="fas fa-spinner fa-spin"></i>
					</div>
				</slot>
			</div>
			</div>
		</div>
		</div>


		<Modal @closeDialog="visible = false" :visible="visible" :errorMessage="errorMessage"></Modal>
		<h2>Record Edit History</h2>
		<div class="row">
			<div class="container">
				<div class="col-md-offset-4 col-md-4 col-xs-12">
					<form>
						<div class="form-group">
							<input type="text" class="form-control" placeholder="Record Id" v-model="recordId">
						</div>
						<div class="form-group">
							<select class="form-control" v-model="table">
								<option value="" disabled selected>Select a table</option>
								<option v-for="table in tables" :key="table">{{ table }}</option>
							</select>
						</div>
						<div class="form-group">
							<input class="form-control" placeholder="Number of results to display" v-model.number="limit" type="number">
						</div>
                        <button type="button" v-on:click="getHistory" class="btn btn-default submit-btn">Submit</button>
						<p v-if="err" class="err">Please enter an ID and select a table.</p>
                    </form>
					<div v-if="loading" class="fa-3x text-center" style="margin-top: 10px">
						<i class="fas fa-spinner fa-spin"></i>
					</div>
				</div>
				<div class="col-xs-12">
					<h4 v-if="wasDeleted" class="text-center" style="font-style: italic; margin-top: 30px"><b>Note:</b> This record was deleted, rollbacks not available</h4>
					<div v-if="!historyExists" class="text-center" style="font-style: italic; margin-top: 30px">
						<p><b>No record history found.</b></p>
						<p>Please check that the ID and table are correct.</p>
						<p>Also note that edit history may not exist for a record if changes have not occurred since its creation.</p>
					</div>
				</div>
			    <div id="edit_history">
					<template v-if="changes.length > 0">
						<template v-for="change in changes">
							<div class="change_row">
								<div>
									<p class="pull-right" style="font-style: italic">{{`Record ${recordId} from ${change.table_name} table`}}</p>
									<h4>{{ constructHeader(change) }}</h4>
								</div>
								<div class="change_data">
									<div class="panel panel-success">
										<div class="panel-heading" style="font-weight: 700">Values Changed:</div>
										<div class="panel-body">
											<div v-for="field in displayChange(change)">
												<span style="display: block">{{ field }}</span>
											</div>
										</div>
									</div>
									<div class="panel panel-info">
										<div class="panel-heading" style="font-weight: 700">Previous Values:</div>
										<div class="panel-body">
											<div v-for="field in castOldDataToString(change.row_data, change.changed_fields)">
												<span style="display: block">{{ field }}</span>
											</div>
											<button v-if="change.changed_fields && !wasDeleted " v-on:click="revert(change.id)" class="btn btn-primary btn-block" style="font-weight: 700; margin-top: 20px;">Rollback to previous values</button>
										</div>
									</div>
								</div>
							</div>
						</template>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import Modal from './shared/Modal';

export default {
	name: 'EditHistory',
	components: {
		Modal
	},
	data() {
		return {
			recordId: null,
			table: null,
			limit: null,
            changeLogId: null,
			wasDeleted: false,
			records: [],
            changes: [],
			loading: false,
			visible: false,
			errorMessage: '',
			toggleModal: false,
			revertLoading: false,
			err: false,
			historyExists: true,
			tables: [],
		}
	},
	beforeMount: function () {
        // show all tables that the logged in user has access to
        const allTables = JSON.parse(localStorage.getItem('tables'));
        this.tables = allTables.map((table) => {
            return table.name;
        });
	},
	methods: {
		async revert(changelogid) {

			this.toggleModal = true;
			this.revertLoading = true;

			let headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  		  	headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/tables/${this.table}/history/rollback/${this.recordId}/${changelogid}`;

			let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
            method: 'GET',
            headers: headers,
			credentials: 'include'
			}).catch(function(error) {
				err = error;
				this.toggleModal, this.revertLoading = false;
			});

			if ( response.status == 403 ) {
				response = await response.json();
			  alert(response.message);
	  		  window.location.href = '/login';
	  	  	}
			else {
				response = await response.json()
				this.toggleModal = false;
				this.revertLoading = false;
				this.getHistory();
			}
		},


        async getHistory() {

		this.historyExists = true;

		if(!this.recordId || !this.table) {
			this.err = true;
			return;
		}

		this.err = false;


		this.loading = true;

		let headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
		headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/tables/${this.table}/history/${this.recordId}?limit=${this.limit ? this.limit : 20}`;

        let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
            method: 'GET',
            headers: headers,
			credentials: 'include'
        }).catch(function(error) {
            err = error;
			this.loading = false;
        });


		if ( response.status == 403 ) {
			response = await response.json();
		    alert('Insufficient privileges.');
  		  	window.location.href = '/login';
	  	} else if (!response.ok) {
			response = await response.json();
			console.log(response)
		} else {


			response = await response.json();

			if(!response.data[0].get_changelog) {
				this.historyExists = false;
			} else {

				this.changes = response.data[0].get_changelog;

				// Check if any changes were a delete:
				this.changes.find(o => o.action === 'D') ? this.wasDeleted = true : this.wasDeleted = false;
				
				// Logic to omit records with only an "updated" timestamp for their changes.
				let recordsWithChanges = [];
				this.changes.forEach((change) => {
					if (change.changed_fields && Object.keys(change.changed_fields).length === 1 && Object.keys(change.changed_fields)[0] === 'updated') {
						// Do not want records with only an updated timestamp change.
					} else {
						recordsWithChanges.push(change);
					}
				})
				
				this.changes = recordsWithChanges;

			}



	  		this.loading = false;
		}
        },
		constructHeader(change) {
			let action;

			if (change.action === 'I' ) {
				action = 'Inserted';
			}
			if (change.action === 'U' ) {
				action = 'Updated';
			}
			if (change.action === 'D' ) {
				action = 'Deleted';
			}

			return `${action} on ${change.action_timestamp.substring(0, 19)} by ${change.user_name}`
		},


		async getEditHistory() {
			this.loading = true;
			this.changes = [];

			if ( !this.user || this.user.length <= 6 ) {
				this.loading = false;
				this.visible = true,
				this.errorMessage = 'User field is required.';
				return;
			}

			let converted_user = this.user.replace(/\@/g, '_').replace(/\./g, '_').replace(/[\u0250-\ue007]/g, '');
			let query_string = '';

			if ( this.limit ) {
				query_string += `&limit=${this.limit}`;
			}
			if ( this.start ) {
				query_string += `&start=${this.start}`;
			}
			if ( this.end ) {
				query_string += `&end=${this.end}`;
			}
			if ( query_string ) {
				query_string = `?${query_string}`;
			}

			let err = '';

			let headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  		  headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/users/history/${converted_user}${query_string}`;

			let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
				method: 'GET',
				headers: headers,
				credentials: 'include'
			}).catch(function(error) {
				err = error;
			});

			this.loading = false;

			if ( err ) {
				this.visible = true,
				this.errorMessage = err;
			}
			if ( response.status == 200 ) {
				response = await response.json();
				if ( response.data[0].get_changes ) {
					this.changes = response.data[0].get_changes;
				}
				else {
					this.visible = true,
					this.errorMessage = 'No activity found for this user within the provided date range.';
				}
			}
			else {
				if ( response.status == 403 ) {
		  		  response = await response.json();
		  		  alert(response.message);
		  		  window.location.href = '/login';
		  	  	}
			  	else {
					this.visible = true,
					this.errorMessage = 'An error occurred, please try again.';
				}
			}

			this.loading = false;
		},
		displayChangeMeta(col_data, col_key, change) {
			if ( col_key == 'action' ) {
				if (col_data == 'I' ) {
					col_data = 'Insert';
				}
				if (col_data == 'U' ) {
					col_data = 'Update';
				}
				if (col_data == 'D' ) {
					col_data = 'Delete';
				}
			}
			else if ( col_key == 'id' ) {
				col_data = `change ID ${change.id}`;
			}
			else if ( col_key == 'table_name' ) {
				col_data = `${change.table_name} ID ${change.row_data.id}`;
			}
			else if ( col_key == 'user_name' ) {
				col_data = col_data;
			}
			else if ( col_key == 'action_timestamp' ) {
				let t = col_data.substring(0, 19);
				t = t.replace('T', ' ');
				return t;
			}
			if ( col_key != 'changed_fields' && col_key != 'row_data' ) {
				return col_data;
			}

		},
		displayChange(change) {
			if ( change.action == 'D' ) {
				return '';
			}
			else if (change.action == 'U' ) {
				return this.castChangeDataToString(change.changed_fields);
			}
			else if (change.action == 'I' ) {
				return this.castChangeDataToString(change.row_data);
			}
		},
		castChangeDataToString(change_data) {
			let arrayOfChanges = [];
			for (let [k, v] of Object.entries(change_data)) {
				if(k === 'updated') {
				} else {
					arrayOfChanges.push(`${k}: ${v}`);
				}
			}
			return arrayOfChanges;
		},
		castOldDataToString(row_data, changed_fields) {
			if(!changed_fields) {
				return;
			}
			let arrayOfPreviousData = [];
			for (let [k, v] of Object.entries(changed_fields)) {
				for (let [k2, v2] of Object.entries(row_data)) {
					if(k === k2 && k !== 'updated') {
						arrayOfPreviousData.push(`${k2}: ${v2}`);
					}
				}
			}
			return arrayOfPreviousData;
		}
	}
}

</script>

<style scoped>

pre {
	font-family: Avenir !important;
}

.contain {
	margin-top: 100px;
}
h2 {
	text-align: center;
}

form {
	margin-top: 25px;
}

.submit-btn {
	width: 100%;
	background-color: #3498DB;
	color: white;
	font-weight: 600;
}

#edit_history {
	clear: both;
	padding-top: 20px;
	width: 90%;
	margin: auto;
}

#edit_history .change_meta {
	width: 100%;
	padding-left: 9.5px;
}

#edit_history .change_meta div {
	width: 20%;
	display: inline-block;
	position: relative;
	top: 12px;
}

#edit_history .change_row {
	background: white;
	border: 1px solid #ccc;
	padding: 20px;
	border-radius: 10px;
	margin-bottom: 20px;
}
.modal-mask {
  position: fixed;
  z-index: 200;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 75%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  text-align: center;
}

.modal-container .btn {
  margin: 0 auto;
}

.modal-header {
  margin-top: 0;
  color: #2c3e50;
  font-size: 30px;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  margin: 0 auto;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.err {
	text-align: center;
	font-size: 12px;
	color: red;
	padding-top: 10px;
}

</style>
